import React, { createContext, useState } from 'react'
import ModalForm from '../components/Shared/ModalForm'
import ConfirmationModal from '../components/Shared/ConfirmationModal'

const ModalContext = createContext({})

export const withModals = ComponentWithModals => props => (
  <ModalContext.Consumer>
    {({ modalActions, modalData }) => <ComponentWithModals
      modalActions={modalActions}
      modalData={modalData} {...props}
    />}
  </ModalContext.Consumer>
)

const Modals = props => {
  const [modalData, setModalData] = useState(null)
  const modalActions = {
    openLoginModal: () => setModalData({ name: 'Login' }),
    openSignupModal: ({ edition }) => setModalData({ name: 'Signup', edition: edition }),
    openModal: (modalData, cb) => {
      setModalData(modalData)
      cb && cb()
    },
    closeModal: (cb) => {
      setModalData(null)
      cb && cb()
    }
  }

  return (
    <ModalContext.Provider value={{ modalActions: modalActions, modalData: modalData }}>
      <ModalForm modalActions={modalActions} modalData={modalData} />
      <ConfirmationModal modalActions={modalActions} modalData={modalData} />
      {props.children}
    </ModalContext.Provider>
  )
}

export default Modals
